module.exports = __webpack_public_path__ + "img/scene5.f7af26b1.png";